// The provider and silent token requests must use the same scopes: Auth0
// caches tokens by scope, and drift can prevent refresh-token restoration.
export const AUTH0_SCOPE = 'read:users offline_access';
